import { render, staticRenderFns } from "./DepositDetail.vue?vue&type=template&id=3f092b04&scoped=true"
import script from "./DepositDetail.vue?vue&type=script&lang=js"
export * from "./DepositDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f092b04",
  null
  
)

export default component.exports